import ActualsPeriodColumnTemplateSource from "./ActualsPeriodColumnTemplateSource.js";
import DynamicBudgetPeriodColumnTemplateSource from "./DynamicBudgetPeriodColumnTemplateSource.js";
import ForecastEstimatePeriodColumnTemplateSource from "./ForecastEstimatePeriodColumnTemplateSource.js";
import ModelFactory from "../../../../ModelFactory.js";

/**
 * Factory creating instances of AbstractPeriodColumnTemplateSource.
 */
class PeriodColumnTemplateSourceFactory extends ModelFactory {
	allClasses() {
		return [
			ActualsPeriodColumnTemplateSource,
			DynamicBudgetPeriodColumnTemplateSource,
			ForecastEstimatePeriodColumnTemplateSource,
		];
	}

	_findClassFromJson(json) {
		if (json.isBudgetColumn) {
			return DynamicBudgetPeriodColumnTemplateSource;
		}

		if (json.forecastEstimateId) {
			return ForecastEstimatePeriodColumnTemplateSource;
		}

		return ActualsPeriodColumnTemplateSource;
	}
}

const periodColumnTemplateSourceFactory =
	new PeriodColumnTemplateSourceFactory();

export default periodColumnTemplateSourceFactory;
